// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 592 ? "common" : chunkId) + "." + {"80":"ee8f6d978ff8e077","592":"7ad47d001c62d6ef","670":"240d3a269699ac82","928":"5235b06b999ce04e"}[chunkId] + ".js";
};